import { React, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import parse from 'html-react-parser'
import { useSelector } from 'react-redux';
import dynamic from 'next/dynamic'

import Header from '../header'
import Container from './grid/container'

const Footer = dynamic(() => import('../footer'))
const MiniCart = dynamic(() => import('../cart/minicart'))
const Searching = dynamic(() => import('../searching'))
const ListContainer = dynamic(() => import('./list/listcontainer'))
const AlphaList = dynamic(() => import('../taxonomies/alphafilter/alphalist-spareparts'))

import store from '../../redux/store'
import { removeUser } from '../../redux/user.slice';
import { clearShipping } from '../../redux/shipping.slice';
import { clearAddresses } from '../../redux/address.slice';

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

import Scripts from '../scripts';

import Breadcrumbs from "../../components/Breadcrumbs";

function Controller({ item, list, menu, config, filter_list, brand_list, role, price, step, slugs }) {

    const router = useRouter();
    const user = useSelector((state) => state.user);
    const cart = useSelector((state) => state.cart);
    const grid_view = useSelector((state) => state.grid_view.grid_view);
    const [loading, set_loading] = useState(false);
    const [searching, set_searching] = useState(true);
    const [stored_list, set_stored_list] = useState(list);
    const [available_filters, set_available_filters] = useState(filter_list);
    const [available_brands, set_available_brands] = useState(brand_list);
    const [error, set_error] = useState(false);

    useEffect(() => {
        const taxonomy_data_api_call = async (url, type) => {
            // dont render on server for blank things
            set_searching(true)
            set_loading(true)
            if (!router.isReady) return;
            const page = router.query.page ? router.query.page : '1'
            const sort = router.query.sort ? router.query.sort : 'a-z'
            const price_from = router.query.price_from ? router.query.price_from : null
            const price_to = router.query.price_to ? router.query.price_to : null

            if (merchant) {
                var endpoint = '/taxonomies-products-pricing/'
                var headers = {
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + token
                }
            } else {
                var endpoint = '/taxonomies-products/'
                var headers = {
                    'Content-Type': 'application/json',
                }
            }

            if (router.query.filters) {
                const filters = JSON.parse(router.query.filters)
                var body = {
                    filters: filters,
                    device_name: 'browser',
                    page: page,
                    sort: sort,
                    price_from: price_from,
                    price_to: price_to
                }
            } else {
                var body = {
                    device_name: 'browser',
                    page: page,
                    sort: sort,
                    price_from: price_from,
                    price_to: price_to
                }
            }

            fetch(
                process.env.NEXT_PUBLIC_API_URL + endpoint + type + '/' + url,
                {
                    body: JSON.stringify(body),
                    headers: headers,
                    method: 'POST'
                }
            )
                .then(response => {
                    // reject not ok response
                    if (!response.ok) {
                        return Promise.reject(response)
                    }
                    return response.json() // or return response.text()
                })
                .catch(async response => {
                    if (!response.ok && response.redirected) {
                        set_error('You have logged in on another device, please login again to see pricing')
                    }
                    const error = await response.json().then(text => text)
                    return Promise.reject(error)
                })
                .then(data => {
                    set_stored_list(data.data)
                })
                .catch((error) => {
                    console.warn(error);
                });

            // lets check if we are a filters (on category pages) or a sparepart-filter (on sparepart pages)
            var sidebar_type = 'filter'
            switch (type) {
                case "category":
                    sidebar_type = 'filter'
                    break;
                case "sparepart":
                    sidebar_type = 'sparepart-filter'
                    break;
                case "brand":
                    sidebar_type = 'filter'
                    break;
                case "stockist":
                    sidebar_type = 'filter'
                    break;
                case "filter":
                    sidebar_type = 'filter'
                    break;
            }
            var endpoint = '/taxonomy-filtered'
            if (merchant) {
                var headers = {
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + token
                }
            } else {
                var headers = {
                    'Content-Type': 'application/json',
                }
            }

            if (router.query.filters) {
                const filters = JSON.parse(router.query.filters)
                var body = {
                    filters: filters,
                    device_name: 'browser',
                    type: sidebar_type,
                    slug: url
                }
            } else {
                var body = {
                    device_name: 'browser',
                    type: sidebar_type,
                    slug: url
                }
            }

            fetch(
                process.env.NEXT_PUBLIC_API_URL + endpoint,
                {
                    body: JSON.stringify(body),
                    headers: headers,
                    method: 'POST'
                }
            )
                .then(response => {
                    // reject not ok response
                    if (!response.ok) {
                        return Promise.reject(response)
                    }
                    return response.json() // or return response.text()
                })
                .catch(async response => {
                    const error = await response.json().then(text => text)
                    return Promise.reject(error)
                })
                .then(data => {
                    set_available_filters(data.data)
                })
                .catch((error) => {
                    console.warn(error);
                });


            var endpoint = '/taxonomy-filtered'
            if (merchant) {
                var headers = {
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + token
                }
            } else {
                var headers = {
                    'Content-Type': 'application/json',
                }
            }

            if (router.query.filters) {
                const filters = JSON.parse(router.query.filters)
                var body = {
                    filters: filters,
                    device_name: 'browser',
                    type: 'brand',
                    slug: url
                }
            } else {
                var body = {
                    device_name: 'browser',
                    type: 'brand',
                    slug: url
                }
            }

            fetch(
                process.env.NEXT_PUBLIC_API_URL + endpoint,
                {
                    body: JSON.stringify(body),
                    headers: headers,
                    method: 'POST'
                }
            )
                .then(response => {
                    // reject not ok response
                    if (!response.ok) {
                        return Promise.reject(response)
                    }
                    return response.json() // or return response.text()
                })
                .catch(async response => {
                    const error = await response.json().then(text => text)
                    return Promise.reject(error)
                })
                .then(data => {
                    set_available_brands(data.data)
                })
                .catch((error) => {
                    console.warn(error);
                });

            set_loading(false)
            set_searching(false)
        }

        const api_call_basket_validate = async () => {
            if (token) {
                var endpoint = '/validate_cart'
                var headers = {
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + token
                }
                
              fetch(
                process.env.NEXT_PUBLIC_API_URL + endpoint,
                {
                    body: JSON.stringify({
                        cart: cart
                    }),
                    headers: headers,
                    method: 'POST'
                }
                ) .then(response => {
                  // reject not ok response
                  if (!response.ok) {
                    return Promise.reject(response)
                  }
                  return response.json() // or return response.text()
                })
                .catch(async response => {
                  if (!response.ok && response.redirected) {
                    set_error('You have logged in on another device, please login again to continue!')
                  }
                  const error = await response.json().then(text => text)
                  return Promise.reject(error)
                })
                .then(data => {
                  set_error(false)
                  // herre I need to overwrite the product that we are using with the new data
                })
                .catch((error) => {
                  console.warn(error);
                });
            } 
          }

        var token = false
        var merchant = false
        if (user[0] != undefined) {
            token = user[0].token
            if (user[0].roles != undefined && user[0].roles.findIndex((element) => element.name == "merchant") >= 0) {
                merchant = true
            }
        }


        // we only want to call this one if we are actually logged in as a merchant, in that case, always call
        // or if we have filters set
        if (!role && (merchant || router.query.filters || router.query.page || router.query.sort)) {
            taxonomy_data_api_call(item.url, item.type);
        } else {
            set_loading(false)
            set_searching(false)
        }

        if(!merchant){
            api_call_basket_validate()
        }

    }, [router, user, item, list, role]);


    // if list changes, reload it into the store
    useEffect(() => {
        set_stored_list(list)
        set_available_filters(filter_list)
        set_available_brands(brand_list)
    }, [router, list, filter_list, brand_list])

    const logout_and_redirect_to_login = () => {
        store.dispatch(clearShipping())
        store.dispatch(clearAddresses())
        store.dispatch(removeUser())
        router.push('/login', undefined, { shallow: true })
    }

    const [links, setLinks] = useState([]);

    useEffect(() => {
        let array = [];
    
        array.push(["Select Brand", "/spareparts"]);
        slugs.map((url, index) => {
          if (index == 0) array.push(["Select Appliance", slugs[index]]);
          if (index == 1)
            array.push([
              "Select Model/Range",
              slugs[index - 1] + "/" + slugs[index],
            ]);
          if (index == 2) array.push([item.name, "/spareparts"]);
        });
    
        setLinks(array);
      }, [item]);
    
        
    return (
        <>
            <div className="wrapper h-full flex flex-col">
                <Header menu={menu} config={config}></Header>
                <Breadcrumbs links={[links]} />

                {(error) ? (
                    <Popup open={true} closeOnDocumentClick={false} closeOnEscape={false} position="right center">
                        <div className="bg-white border border-2 p-10 flex flex-col items-center">
                            {error}
                            <span onClick={() => logout_and_redirect_to_login()} className="mt-5 btn btn-primary p-3 w-40">Login</span>
                        </div>
                    </Popup>
                ) : ('')}
                {
                    (searching) ? (<Searching></Searching>) : (
                        // in here I need a condition to see if we have children
                        (item && item.children && item.children.length > 0 && step <= 3) ? (
                            <AlphaList list={item.children} type={item.type} title={item.type} step={step} filters={false}
                            name={item.name} parent={step > 2 ? item.parent.name : item.name} brandUrl={step < 3 ? item.url : item.parent.url} applianceUrl={step < 3 ? "" : "/" + item.url}
                            media={
                                step > 2
                                ? item.parent.media[0]?.original_url
                                : item.media[0]?.original_url
                            }
                            ></AlphaList>
                        ) : (
                            // if grid_view, show one, else show other
                            (grid_view) ? (
                                <Container item={item} list={stored_list} filter_list={available_filters} brand_list={available_brands} loading={loading} price={price}
                                parent={step < 3 ? item.name : item.parent.name} name={item.name} slugs={links} urls={slugs}></Container>
                            ) : (
                                <ListContainer item={item} list={stored_list} filter_list={available_filters} brand_list={available_brands} loading={loading} price={price}
                                parent={step < 3 ? item.name : item.parent.name} name={item.name} slugs={links} urls={slugs}></ListContainer>
                            )
                        )
                    )
                }
                {(item && item.description) ? (parse(item.description)) : ('')}
                <Footer menu={menu} config={config}></Footer>
            </div>
            <MiniCart></MiniCart>
            <Scripts javascripts={item.javascripts}></Scripts>
        </>
    )
}


export default Controller